import { CasaviSettingsView } from "./casavi-settings.view";

export function CasaviSettingsRoutes() {
  return <CasaviSettingsView />;
}
